import React, { useContext } from 'react';
import { Base, Flex, Button, Text } from '@stepstone-genesis/components';
import { FlexGrid, FlexColumn } from '@stepstone-genesis/components';
import { JobItemLegacyWrapper } from '@stepstone/matching-design-system';
import { LangContext } from 'modules/hub/components/EditorContent/LangContext';
import { CompanyContext } from 'modules/hub/components/EditorContent/CompanyContext';
import labels from 'modules/hub/components/EditorContent/labels';
const COMPONENT_ID = 'companyResultlistWidget';
const Jobfeed = ({ jobs }) => {
    const lang = useContext(LangContext);
    const { companyId, numericCompanyId, companyName } = useContext(CompanyContext);
    const trackingCompanyId = numericCompanyId ?? companyId;
    const allJobsUrl = jobs.find((j) => j.companyResultListUrl)?.companyResultListUrl ?? null;
    return (React.createElement(Base, { as: "section", id: "Jobfeed", "data-testid": "jobfeed-widget", paddingY: "spaceL", "data-atx-component": COMPONENT_ID, "data-atx-onvisibleelement-payload": JSON.stringify({
            linkName: 'widgetVisible',
            componentId: COMPONENT_ID,
            elementActioned: 'Widget',
            elementAction: 'Visible',
            elementActionValue: companyName ?? 'noValue',
            companyId: trackingCompanyId ?? 'noValue',
        }) },
        React.createElement(Text, { as: "h2", fontWeight: "fontWeightBold", sx: {
                fontSize: 'fontSizeXl',
                lineHeight: 'lineHeightXl',
                color: 'colorFocusOuter',
                margin: 0,
                marginBottom: 'spaceM',
            } }, labels[lang].openPositionsTitle),
        React.createElement(FlexGrid, { gutter: "spaceS2" }, jobs.map((job, index) => (React.createElement(FlexColumn, { key: job.id ?? index, span: 12 },
            React.createElement(Base, { "data-testid": "jobfeed-job-card", "data-atx-component": COMPONENT_ID, "data-atx-onclick-payload": JSON.stringify({
                    linkName: 'jobCardLinkClick',
                    componentId: COMPONENT_ID,
                    elementActioned: 'jobCardLink',
                    elementAction: 'Click',
                    elementActionValue: String(index + 1),
                    companyId: trackingCompanyId ?? 'noValue',
                    jobId: job.id != null ? String(job.id) : 'noValue',
                    jobAdSource: 'companyHubPremium_companyResultlistWidget_jobcardLink',
                }), sx: {
                    '[data-at="job-item-top-label"]': {
                        lineHeight: 'lineHeightXs',
                        color: 'colorAccentB2BDefault',
                    },
                    '[data-at="job-item-company-name"] [data-genesis-element="ICON_CONTAINER"], [data-at="job-item-location"] [data-genesis-element="ICON_CONTAINER"], [data-at="job-item-work-from-home"] [data-genesis-element="ICON_CONTAINER"]': { color: 'colorHighlight' },
                    '[data-at="job-item-title"]': { color: 'colorFocusOuter' },
                    '[data-at="job-item-title"]:hover': {
                        color: 'colorFocusOuter',
                    },
                    '[data-genesis-element="CARD"]:hover, [data-genesis-element="CARD"]:focus-within': {
                        boxShadow: 'boxShadowBorderActionable',
                        outline: 'outlineDefault',
                        outlineColor: 'colorAccentB2BHover',
                    },
                } },
                React.createElement(JobItemLegacyWrapper, { id: job.id ?? 0, 
                    // Always an object: JobItemLegacyWrapper reads
                    // `companyLogoProps.url` unguarded, so `undefined` crashes SSR
                    // (500) for any job without a logo. A missing logoUrl renders
                    // the library's transparent placeholder.
                    companyLogoProps: {
                        name: job.companyName ?? '',
                        logoUrl: job.logo || undefined,
                    }, companyNameProps: { name: job.companyName }, titleProps: {
                        title: job.title,
                        url: job.url,
                        openInNewTab: true,
                        onClick: () => window.open(job.url, '_blank'),
                    }, topLabelsProps: { labels: [] }, jobMetadataProps: {
                        jobMetadataDateProps: {
                            lang: 'de',
                            datePosted: job.publishedDate ?? '',
                        },
                        jobMetadataLocationProps: {
                            location: job.location,
                        },
                        jobMetadataLabelsProps: undefined,
                        jobMetadataSalaryProps: undefined,
                        jobMetadataWorkFromHomeProps: {
                            workFromHome: job.workType?.length
                                ? job.workType.join(', ')
                                : undefined,
                        },
                        jobMetadataTravelTimeProps: undefined,
                    } })))))),
        allJobsUrl && (React.createElement(Flex, { flxJustify: "center", marginTop: "spaceM" },
            React.createElement(Button, { as: "a", id: "jobfeed-all-jobs-link", "data-testid": "jobfeed-all-jobs-link", a11yLabel: labels[lang].allJobsButton, href: allJobsUrl, target: "_blank", rel: "noopener noreferrer", variant: "primary", "data-atx-component": COMPONENT_ID, "data-atx-onclick-payload": JSON.stringify({
                    linkName: 'seeAllJobsClick',
                    componentId: COMPONENT_ID,
                    elementActioned: 'seeAllJobs',
                    elementAction: 'Click',
                    elementActionValue: 'noValue',
                    companyId: trackingCompanyId ?? 'noValue',
                }), sx: {
                    color: 'colorWhite',
                    borderRadius: 'radiusRound',
                    borderColor: 'colorStatusInfoFg',
                    backgroundColor: 'colorStatusInfoFg',
                    fontWeight: 'fontWeightSemibold',
                    ':hover, :focus': {
                        color: 'colorWhite',
                        borderColor: 'colorAccentB2BHover',
                        backgroundColor: 'colorAccentB2BHover',
                    },
                } }, labels[lang].allJobsButton)))));
};
export default Jobfeed;
